import Cookies from "js-cookie";

const TokenKey = "Admin-Token";

const oneKey = "child";

/**
 * 用于存放 token以及平台切换
 * @returns {undefined}
 */

export function getToken() {
  let data = Cookies.get(TokenKey);
  let token = undefined;
  if (data) {
    data = JSON.parse(Cookies.get(TokenKey));
    if ("talkie" === data.platform) {
      token = data.token;
    }
  }
  return token;
}


export function setToken(token, platform) {
  const data = {
    token: token,
    platform: platform
  };
    Cookies.set(TokenKey, data,  { domain: 'test-control.nutptt.com' });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}


/**
 *  一键登录 用的cookies
 */

 export function setOneKey(token){
  return Cookies.set(oneKey, token);
 }

 export function getOneKey(){
  return Cookies.get(oneKey);
 }

 export function removeOneKey() {
  return Cookies.remove(oneKey);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js